<template>
  <v-card flat color="transparent">
    <v-card-text>
      <span class="title text-md-center">Položky rezania</span>
      <v-container grid-list-md v-if="items.length == 0">
        <v-layout row wrap>
          <v-flex xs12>
            <span>Prosím zadajte prvý dielec.</span>
          </v-flex>
        </v-layout>
      </v-container>
      <v-layout row wrap v-else pt-3>
        <v-flex xs12>
          <v-expansion-panel class="elevation-0">
            <v-expansion-panel-content
              v-for="item in items"
              :key="item.name"
              style="background-color:transparent"
            >
              <span slot="header" class="subheading text--transparent">{{item.name}}</span>

              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 px-2 pt-0>
                    <span class="subheading">{{ item.material.fullName }}</span>
                    <div class="pb-2">
                      Produkt kód: {{item.material.productCode}} - Cena tabule:
                      {{item.material.price}} €
                    </div>
                    <v-img
                      class="elevation-2"
                      :src="image(item.material)"
                      aspect-ratio="3"
                      max-width="400"
                      max-height="200"
                    ></v-img>
                  </v-flex>

                  <v-flex xs12 md6>
                    <v-list dense style="background-color:transparent">
                      <v-list-tile>
                        <v-list-tile-content>Hrúbka:</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ item.thickness }}</v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>Počet kusov:</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ item.quantity }}</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-flex>

                  <v-flex xs12 md6>
                    <v-list dense style="background-color:transparent">
                      <v-list-tile>
                        <v-list-tile-content>Dĺžka:</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ item.width }}</v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>Šírka:</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ item.height }}</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-flex>

                  <v-flex xs12>
                    <v-divider></v-divider>
                    <v-list dense style="background-color:transparent">
                      <v-list-tile>
                        <v-list-tile-content>Dupla:</v-list-tile-content>
                        <v-list-tile-content v-if="item.duplex" class="align-end">áno</v-list-tile-content>
                        <v-list-tile-content v-else class="align-end">nie</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                    <v-list dense style="background-color:transparent">
                      <v-list-tile>
                        <v-list-tile-content>Otáčanie:</v-list-tile-content>
                        <v-list-tile-content v-if="item.rotate" class="align-end">povolené</v-list-tile-content>
                        <v-list-tile-content v-else class="align-end">nepovolené</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-flex>

                  <v-flex xs12>
                    <v-divider></v-divider>

                    <v-list dense style="background-color:transparent">
                      <v-list-tile>
                        <v-list-tile-content>Hrana vzadu:</v-list-tile-content>
                        <v-list-tile-content
                          class="align-end"
                          v-if="item.edge.back != null"
                        >{{ item.edge.back.name }}</v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>Hrana vpredu:</v-list-tile-content>
                        <v-list-tile-content
                          class="align-end"
                          v-if="item.edge.front != null"
                        >{{ item.edge.front.name }}</v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>Hrana vľavo:</v-list-tile-content>
                        <v-list-tile-content
                          class="align-end"
                          v-if="item.edge.left != null"
                        >{{ item.edge.left.name }}</v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>Hrana vpravo:</v-list-tile-content>
                        <v-list-tile-content
                          class="align-end"
                          v-if="item.edge.right != null"
                        >{{ item.edge.right.name }}</v-list-tile-content>
                      </v-list-tile>
                    </v-list>

                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="!item.file" small color="primary" @click="editItem(item)">Editovať</v-btn>
                <v-btn small color="primary" @click="removeItem(item.id)">Zmazať</v-btn>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-card-text>
    <ConfirmDialog ref="confirm" />
  </v-card>
</template>

<script>
import images from "@/views/cutting/js/images";
import * as types from "@/store/types";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog";
import _ from "lodash-es";

export default {
  name: "CuttingItem",
  components: {
    ConfirmDialog
  },
  data() {
    return {
      images: images
    };
  },
  computed: {
    items() {
      return _.orderBy(
        this.$store.getters.cuttingItems,
        [item => item.name.toLowerCase()],
        ["asc"]
      );
    }
  },
  methods: {
    removeItem(id) {
      this.$refs.confirm
        .open("Vymazanie položky", "Naozaj chcete vymazať položku?", {
          color: "warning"
        })
        .then(confirm => {
          if (confirm) {
            this.$store.commit(types.REMOVE_ITEM_FROM_STORE, id);
            this.$store.commit(types.SHOW_GLOBAL_ALERT, {
              value: true,
              message: "Položka bola zmazaná",
              color: "success"
            });
            this.$store.commit("removeOptimizationItems");
          }
        });
    },
    editItem(item) {
      this.$refs.confirm
        .open("Editovanie položky", "Naozaj chcete editovať položku?", {
          color: "primary"
        })
        .then(confirm => {
          if (confirm) {
            let edit = JSON.parse(JSON.stringify(item));
            this.$store.commit(types.REMOVE_ITEM_FROM_STORE, item.id);
            this.$emit("editItem", edit);
          }
        });
    },
    image(material) {
      return this.images.demosImageUrl(material);
    }
  }
};
</script>

<style>
</style>